module.exports = __webpack_public_path__ + "static/media/DSC09701.41bb5734.jpg";